import React, { useState } from 'react';
import { InputForm } from './InputForm';
import { HeadlineResults } from './HeadlineResults';
import { AISettings } from './AISettings';
import { HeadlineType, FormInputs } from '../types';
import { generateAIHeadlines } from '../utils/openai';
import { generateHeadlines } from '../utils/headlineGenerator';

export function Tool() {
  const [headlines, setHeadlines] = useState<HeadlineType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [useAI, setUseAI] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const [selectedModel, setSelectedModel] = useState('gpt-3.5-turbo');
  const [inputs, setInputs] = useState<FormInputs>({
    topic: '',
    keyword: '',
    industry: 'technology',
    audience: 'intermediate',
    goal: 'educational',
    platform: 'blog'
  });

  const handleGenerate = async () => {
    setIsLoading(true);
    try {
      const results = useAI && apiKey
        ? await generateAIHeadlines(inputs, apiKey, selectedModel)
        : generateHeadlines(inputs);
      setHeadlines(results);
    } catch (error) {
      console.error('Error generating headlines:', error);
      // Fallback to template-based generation
      const fallbackResults = generateHeadlines(inputs);
      setHeadlines(fallbackResults);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="space-y-8">
      <div className="bg-white rounded-xl shadow-lg p-6">
        <InputForm
          inputs={inputs}
          setInputs={setInputs}
          onGenerate={handleGenerate}
          isLoading={isLoading}
        />
        <AISettings
          useAI={useAI}
          setUseAI={setUseAI}
          apiKey={apiKey}
          setApiKey={setApiKey}
          selectedModel={selectedModel}
          setSelectedModel={setSelectedModel}
        />
      </div>
      <HeadlineResults headlines={headlines} />
    </section>
  );
}